// extracted by mini-css-extract-plugin
module.exports = {"modal__overlay":"Modal_modal__overlay__3Q0vB","modal__block":"Modal_modal__block__3BLSp"};